module.exports = __webpack_public_path__ + "img/clock-2.f78bad63.svg";